import React, {Component} from 'react';
import {detailProduct, storeProducts} from "./data";

const ProductContext = React.createContext();

class ProductProvider extends Component {
    state = {
        products: [],
        detailProduct: detailProduct,
        cart:[],
        cartSubTotal:0,
        cartTax:0,
        cartTotal:0

    };
    componentDidMount() {
        this.setProduct();

    }

    setProduct = () =>{
        let tempProducts = [];
        storeProducts.forEach(item => {
            const oneItem = {...item};
            tempProducts = [...tempProducts,oneItem];
        });
        this.setState(()=>{
            return {products:tempProducts}
        })
    };
    getItem = id =>{
        return this.state.products.find(item => item.id === id)
    };

    handleDetail = (id) => {
        const product = this.getItem(id);
        this.setState(()=>{
            return{detailProduct:product}
        })
    };
    addToCart = (id) => {
        let tempProducts = [...this.state.products];
        const index = tempProducts.indexOf(this.getItem(id));
        const product = tempProducts[index];
        product.inCart = true;
        product.count = 1;
        const price = product.price;
        product.total = product.count * product.price;
        this.setState(()=>{
            return{products:tempProducts, cart:[...this.state.cart,product]};
        },()=>this.addTotals());
    };
    increment = id =>{
        let tempCart = [...this.state.cart];
        const selectedProduct = tempCart.find(item => item.id === id);
        const index = tempCart.indexOf(selectedProduct);
        const product = tempCart[index];

        product.count = product.count + 1;
        product.total = product.count * product.price;

        this.setState(()=>{
            return{
                cart:[...tempCart]
            }
        },()=> this.addTotals()
    )};
    decrement = id =>{
        let tempCart = [...this.state.cart];
        const selectedProduct = tempCart.find(item=>item.id === id);
        const index = tempCart.indexOf(selectedProduct);
        const product = tempCart[index];

        product.count = product.count - 1;
        if (product.count <=  0){this.removeItem(id)}
        else {
            this.setState(()=>{
                    return{
                        cart:[...tempCart]
                    }
                },()=> this.addTotals()
            )
        }
    };
    removeItem = (id)=>{
        let tempProducts = [...this.state.products];
        let tempCart = [...this.state.cart];

        tempCart = tempCart.filter(item =>item.id !==id);
        const index = tempProducts.indexOf(this.getItem(id));
        let removedProduct = tempProducts[index];
        removedProduct.inCart = false;
        removedProduct.count = 0;
        removedProduct.total = 0;
        this.setState(()=>{
            return {
                cart:[...tempCart],
                products:[...tempProducts]
            };
        },()=>this.addTotals())


    };
    removeAll = ()=>{
        this.setState(() => {
            return{cart:[]};
        },()=>{
            this.setProduct();
            this.addTotals();
        })
    };
    addTotals = ()=>{
        let subTotal = 0;
        this.state.cart.map(item =>(subTotal += item.total));
        const tempTax = subTotal*0.06;
        const tax = parseFloat(tempTax.toFixed(2));
        const total = subTotal+tax;
        this.setState(()=>{
            return{
                cartSubTotal:subTotal,
                cartTax: tax,
                cartTotal: total
            }
        })
    };

    render() {
        return (
            <ProductContext.Provider value={{
                ...this.state,
                handleDetail: this.handleDetail,
                addToCart: this.addToCart,
                increment:this.increment,
                decrement:this.decrement,
                removeItem:this.removeItem,
                removeAll:this.removeAll,
            }}>
                {this.props.children}
            </ProductContext.Provider>
        );
    }
}

const ProductConsumer = ProductContext.Consumer;

export {ProductProvider, ProductConsumer};
